import constants from '@/config/constants'

export interface IErrorResp {
  code: string
  title: string
  type: string
  detail: string
  instance: string
}

export class CustomError extends Error {
  public errorResponse: IErrorResp

  constructor(errorResponse: IErrorResp) {
    super(errorResponse.title)
    this.errorResponse = errorResponse
    this.name = errorResponse.code
  }
}

export function prepareError(ex: unknown): CustomError {
  if (ex instanceof CustomError) return ex
  const err = ex as { name?: string }
  return new CustomError({
    code:
      err?.name === 'TypeError'
        ? constants.ERROR_CODES.CONNECTIVITY
        : constants.ERROR_CODES.UNKNOWN,
    title: '',
    type: '',
    detail: '',
    instance: ''
  } as IErrorResp)
}
